export default {
    // VStudio20PresetsPreset
    "Apply": "Appl.",
    "Save": "Sauv.",
    
    // VStudio20PresetsOpened
    "Scene presets": "Presets de scène",
    "Shortcut Keys": "Utilisation des raccourcis",
    "Presets 1–10": "Presets 1–10",
    "Presets 11–36": "Presets 11–36",
    "Save and restore": "Sauvegarder et restaurer",
    "Graphics visibility": "Visibilité des graphiques",
    "Selected sources": "Sources sélectionnées",
    "Selected Layout": "Disposition sélectionnée",
    "Audio configuration": "Configuration audio",
    "Add a new preset": "Ajouter un nouveau preset",
    "Close preset panel": "Fermer le panneau des presets",
    "Add": "Ajouter",
    "Remove preset": "Supprimer le preset",
    "Remove preset \"": "Supprimer le preset \"",
    "Remove": "Supprimer",
    "Cancel": "Annuler",
    "Save configuration": "Sauvegarder la configuration",
    "Save current configuration in preset \"": "Sauvegarder la configuration actuelle dans le preset \"",
    "Rename preset": "Renommer le preset",
    
    // VStudio20PresetsClosed
    "Open presets panel": "Ouvrir le panneau des presets"
}